<app-dialog-base [showLoadingSpinner]="uiState === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Stop Game</span>
  <ng-container dialog-content>
    <div class="red-text">
    <p>
      Stopping a game will prevent any new draws from being created. All active autoplays will be canceled when the game stops. <strong>This cannot be undone.</strong>
    </p>
  </div>
    <form [formGroup]="stopGameForm">
      <mat-form-field appearance="outline" class="full-width margin-top-med">
        <mat-label>When should the game be stopped?</mat-label>
        <mat-select formControlName="stopGameWhen">
          <mat-option value="{{STOP_AFTER_DRAW}}">After current draw</mat-option>
          <mat-option value="{{STOP_AFTER_WINNER}}">After next winner</mat-option>
        </mat-select>
        <mat-hint>
          @if(stopGameWhenOption.value === STOP_AFTER_DRAW) {
            The game will be stopped after the current draw concludes.
          }
          @if(stopGameWhenOption.value === STOP_AFTER_WINNER) {
            The game will be stopped the next time a player wins a draw.
          }
        </mat-hint>
      </mat-form-field>

    </form>
  </ng-container>

  <ng-container actions>
    <button mat-button color="primary"
            (click)="submit()">Submit</button>
  </ng-container>
</app-dialog-base>
